import React, { FC, useCallback, useMemo, useState } from 'react';
import {
	equipmentPerStockLocationCsvReportGeneratorSupplier,
	equipmentPerStockLocationsRestCrudThunksForSupplier,
	fetchAllEquipmentPerStockLocactionForSupplier,
	getEPSLUploadBulkStatus,
	uploadPartialEPSLBulk,
} from '../../thunks/equipment_per_stock_locations_thunks';
import EquipmentPerStockLocationRowDisplay from '../equipment_per_stock_location_row_display/EquipmentPerStockLocationRowDisplay';
import { EquipmentRentalRowDisplay } from '../equipment_rental_row_display/EquipmentRentalRowDisplay';
import { Button, Dropdown, Menu, Popover, message } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { EmptyState } from '../empty_state/EmptyState';
import {
	DownloadOutlined,
	EditOutlined,
	PlusOutlined,
	PrinterOutlined,
	UploadOutlined,
} from '@ant-design/icons';
import { getLinkWIthBackLinkParams } from '../../utils/HistoryUtils';
import {
	getRecordsForCompositeTargetCollection,
	getRecordsForTargetCollection,
} from '../../reducers/standard_reducer_utils';
import { EQUIPMENT_PER_STOCK_LOCATIONS_CRUD_ACTION_CREATORS } from '../../actions/equipment_per_stock_locations_actions';
import {
	compareStrings,
	fetchWithDifferntSearchName,
	getPurchaseOrderId,
	getPurchaseRequestId,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import { DATE_FORMAT } from '../../utils/DataFormatterUtils';
import PaginatedReduxTableWithHeader from '../common/PaginatedReduxTableWithHeader';
import { assetTypesRestCrudThunksForSupplier } from '../../thunks/asset_types_thunks';
import { equipmentTypesRestCrudThunksForSupplier } from '../../thunks/equipment_types_thunks';
import HyperLink from '../common/HyperLink';
import FeildTechSLManagePermissionChecker, {
	canFieldManageStockLocation,
} from '../common/FeildTechSLManagePermissionChecker';
import {
	RECENTLY_UPDATED_SORTER,
	FILTER_CONFIG_NAMES,
	FILTER_FIELD_TYPE,
	ROLE_TYPES,
} from '../../utils/DataConstants';
import moment from 'moment';
import { ExportToCsv } from 'export-to-csv';
import { CSV_EXPORT_DEFAULTS } from '../../utils/DataConstants';
import {
	getReceivedEquipmentFlatfileHeader,
	getFlatfileRecordForReceivedEquipment,
	getFlatfileRecordForReceivedEquipmentExport,
	getEquipmentTypeFlatfileOptions,
	EQUIPMENT_EXPORT_HEADER,
} from './stock_location_constants';
import UploadWithSampleModal from '../flatfile/UploadWithSampleModal';
import DateTimeHover from '../date_time_component/DateTime';
import { renderEquipmenTypeSelect } from '../purchase_order_form/ReplaceEquipmentLineItemModal';
import OWAsyncSelect from '../ow_async_select/OWAsyncSelect';
import FlatfileImporter from '../flatfile/FlatfileImporter';
import TransferEPSLButton from './TransferEPSLButton';
import OWPoll from '../common/OWPoll';
import PartialEPSLUpload from './PartialEPSLUpload';
import { vendorsRestCrudThunksForSupplier } from '../../thunks/vendors_thunks';
import { EPSL_CONDITION_DP_FILTERS } from '../../utils/InventoryUtils';

const EPSL_TC = 'stockLocationAssociatedEquipments';
const EPSL_ADVANCED_FILTERS_TC = 'epslAdvancedFilters';

const StockLocationEquipmentsPage: FC<any> = ({
	match,
	history,
	location,
	fetchEquipmentsPerStockLocation,
	equipmentsPerStockLocation,
	updateEquipmentsPerStocklocationFilters,
	clearAndUpdateFilters,
	stockLocation,
	assetTypes,
	equipmentTypes,
	fetchAssetTypes,
	fetchMultipleAssetTypes,
	fetchEquipmentTypes,
	fetchMultipleEquipments,
	currentUser,
	fetchAllEquipmentPerStockLocation,
	createBulk,
	fetchAllEquipmentTypes,
	exportCsv,
	getBulkUploadStatus,
	uploadPartialBulk,
	vendors,
	fetchVendors,
	fetchMultipleVendors,
}): React.ReactElement => {
	const stockLocationId = useMemo(() => match.params.id, [match.params.id]);

	const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

	const [fetchingEpsl, setFetchingEpsl] = useState(false);
	const [canShowEdit, setCanShowEdit] = useState(false);
	const [epsls, setEpsls] = useState([]);

	const [downloading, setDownloading] = useState(false);
	const [exportingCsv, setExportingCsv] = useState(false);
	const [esplsForUpload, setEpslsForUpload] = useState([]);
	const [uploadPopupVisible, setUploadPopupVisible] = useState(false);
	const [allEquipmentTypes, setAllEquipmentTypes] = useState([]);

	const [bulkUploadInProgress, setBulkUploadInProgress] = useState(false);

	const [partialUploadPopupVisible, setPartialUploadPopupVisible] = useState(false);
	const [bulkUploadInitiated, setBulkUploadInitiated] = useState(false);

	const backText = useMemo(
		() => `Back to ${nullSafeGetOrElse('name', stockLocation, 'Stock location')}`,
		[stockLocation]
	);

	const getLink = useCallback(
		(link) => getLinkWIthBackLinkParams(location, backText, link),
		[backText, location]
	);

	const editAllowed = useMemo(
		() => getRecordsForTargetCollection(equipmentsPerStockLocation, EPSL_TC).length > 0,
		[equipmentsPerStockLocation]
	);

	const allEquipmentTypesNames = useMemo(
		() => getEquipmentTypeFlatfileOptions(allEquipmentTypes),
		[allEquipmentTypes]
	);

	const equipmentsColumns = useMemo(
		() => [
			{
				title: 'Name',
				dataIndex: 'name',
				render: (_, record) => (
					<EquipmentPerStockLocationRowDisplay equipmentPerStockLocation={record} />
				),
			},
			{
				title: 'Received/Transferred From',
				dataIndex: '',
				render: (_, record) => {
					if (
						nullSafeGetOrElse('addedType', record, '').toLowerCase() === 'transferred' &&
						record.fromStockLocationId
					) {
						// const path = `/supplier/stockLocations/detail/${record.fromStockLocationId}`;
						return (
							<div>
								{nullSafeGetOrElse(
									'fromStockLocation.name',
									record,
									`SL # ${record.fromStockLocationId}`
								)}
							</div>
						);
					} else if (
						nullSafeGetOrElse('addedType', record, '').toLowerCase() === 'transferred' &&
						record.fromLocationId
					) {
						return (
							<div>
								{nullSafeGetOrElse(
									'fromLocation.name',
									record,
									`Location # ${record.fromStockLocationId}`
								)}
							</div>
						);
					} else if (compareStrings(record.addedType, 'received') && record.purchaseOrder) {
						const path = `/supplier/purchaseOrders/detail/${record.purchaseOrderId}/details`;
						return (
							<HyperLink
								newTabPath={path}
								text={`PO ${getPurchaseOrderId(record.purchaseOrder)}`}
							/>
						);
					} else if (compareStrings(record.addedType, 'received') && record.purchaseRequest) {
						const path = `/supplier/purchaseRequests/detail/${record.purchaseRequestId}/details`;
						return (
							<HyperLink
								newTabPath={path}
								text={`PR ${getPurchaseRequestId(record.purchaseRequest)}`}
							/>
						);
					} else {
						return '--';
					}
				},
			},
			{
				title: 'Received At',
				dataIndex: 'receivedAt',
				render: (date, record) =>
					date ? (
						<DateTimeHover
							timestamp={date}
							showDate={true}
							timeZone={nullSafeGet('stockLocation.timeZoneId', record)}
						/>
					) : (
						'--'
					),
			},
			{
				title: 'Rental',
				dataIndex: 'isRental',
				render: (text) => <EquipmentRentalRowDisplay isRental={text} />,
			},
		],
		[]
	);

	const canTransfer = useMemo(() => selectedRowKeys.length > 0, [selectedRowKeys.length]);

	const onEquipmentRow = useCallback(
		(record) => ({
			onClick: () =>
				canTransfer
					? false
					: history.push(
							getLink(`/supplier/equipments/equipmentPerStockLocation/detail/${record.id}`)
					  ),
		}),
		[canTransfer, getLink, history]
	);

	const onSelectChange = useCallback((newSelectedRowKeys: React.Key[]) => {
		setSelectedRowKeys(newSelectedRowKeys);
	}, []);

	const rowSelection = useMemo(
		() => ({
			selectedRowKeys,
			onChange: onSelectChange,
		}),
		[onSelectChange, selectedRowKeys]
	);

	const onSelectCancel = useCallback(() => setSelectedRowKeys([]), []);

	const getStateSliceProp = useCallback(
		(propName) => nullSafeGetOrElse(`${EPSL_TC}.${propName}`, equipmentsPerStockLocation, {}),
		[equipmentsPerStockLocation]
	);

	const refreshEquipmentsPerStockLocation = useCallback(() => {
		fetchEquipmentsPerStockLocation(
			{},
			EPSL_TC,
			getStateSliceProp('pagination'),
			getStateSliceProp('sorting'),
			getStateSliceProp('filters')
		);
	}, [fetchEquipmentsPerStockLocation, getStateSliceProp]);

	const onTransferEquipmentsSuccess = useCallback(() => {
		onSelectCancel();
		refreshEquipmentsPerStockLocation();
	}, [onSelectCancel, refreshEquipmentsPerStockLocation]);

	const selectedRecords = useMemo(() => {
		const records = getRecordsForCompositeTargetCollection(equipmentsPerStockLocation, EPSL_TC);
		return records.filter((_) => selectedRowKeys.includes(_.id));
	}, [equipmentsPerStockLocation, selectedRowKeys]);

	const onAddEquipment = useCallback(
		() => history.push(`/supplier/stockLocations/detail/${stockLocationId}/receivedEquipment/new`),
		[history, stockLocationId]
	);

	const filterConfig = useMemo(
		() => [
			{
				label: 'Equipment Type',
				mode: 'multiple',
				fieldName: 'equipmentTypeIds',
				stateSlice: equipmentTypes,
				targetCollectionName: EPSL_ADVANCED_FILTERS_TC,
				fetch: fetchWithDifferntSearchName(fetchEquipmentTypes, 'search'),
				fetchMultiple: fetchMultipleEquipments,
				renderRecord: renderEquipmenTypeSelect,
				component: OWAsyncSelect,
			},
			{
				label: 'Asset Type',
				fieldName: FILTER_CONFIG_NAMES.ASSET_TYPE,
				mode: 'multiple',
				stateSlice: assetTypes,
				targetCollectionName: EPSL_ADVANCED_FILTERS_TC,
				fetch: fetchAssetTypes,
				fetchMultiple: fetchMultipleAssetTypes,
			},
			{
				label: 'Vendor',
				fieldName: FILTER_CONFIG_NAMES.VENDOR,
				mode: 'multiple',
				stateSlice: vendors,
				targetCollectionName: EPSL_ADVANCED_FILTERS_TC,
				fetch: fetchVendors,
				fetchMultiple: fetchMultipleVendors,
			},
			{
				label: 'Received Between',
				labelPrefix: 'Received',
				fieldName: FILTER_CONFIG_NAMES.RECEIVED_AT,
				type: FILTER_FIELD_TYPE.DATE_RANGE,
			},
			{
				fieldName: 'isRental',
				type: 'radioGroup',
				items: [
					{
						label: 'All',
						value: 'undefined',
					},
					{
						label: 'Rented',
						value: 'true',
					},
					{
						label: 'Owned',
						value: 'false',
					},
				],
				showOutsideDropdown: true,
				defaultValue: undefined,
			},
			...EPSL_CONDITION_DP_FILTERS,
		],
		[
			equipmentTypes,
			fetchEquipmentTypes,
			fetchMultipleEquipments,
			assetTypes,
			fetchAssetTypes,
			fetchMultipleAssetTypes,
			vendors,
			fetchVendors,
			fetchMultipleVendors,
		]
	);

	const preAppliedFilters = useMemo(
		() => ({ stockLocationId, isDisbursed: false }),
		[stockLocationId]
	);

	const fetchCurrentSLEntities = useCallback(
		() =>
			fetchAllEquipmentPerStockLocation({
				...preAppliedFilters,
				...{ view: 'exportView' },
			}),
		[fetchAllEquipmentPerStockLocation, preAppliedFilters]
	);

	const onBulkEpslEdit = useCallback(() => {
		setFetchingEpsl(true);
		const promises = [fetchCurrentSLEntities(), fetchAllEquipmentTypes()];
		Promise.all(promises)
			.then((value) => {
				setEpsls(nullSafeGetOrElse('0', value, []));
				setAllEquipmentTypes(nullSafeGetOrElse('1', value, []));
				setCanShowEdit(true);
			})
			.catch((err) => message.error(err))
			.finally(() => setFetchingEpsl(false));
	}, [fetchAllEquipmentTypes, fetchCurrentSLEntities]);

	const fetchAndSetAllETs = useCallback(
		() =>
			new Promise((resolve, reject) => {
				fetchAllEquipmentTypes()
					.then((ets) => {
						setAllEquipmentTypes(ets);
						resolve(true);
					})
					.catch(reject);
			}),
		[fetchAllEquipmentTypes]
	);

	const onUploadClick = useCallback(() => {
		setDownloading(true);
		const promises = [fetchCurrentSLEntities(), fetchAndSetAllETs()];
		Promise.all(promises)
			.then((value) => {
				setEpslsForUpload(nullSafeGetOrElse('0', value, []));
				setUploadPopupVisible(true);
			})
			.catch((err) => message.error(err))
			.finally(() => setDownloading(false));
	}, [fetchAndSetAllETs, fetchCurrentSLEntities]);

	const onPartialUploadClick = useCallback(() => {
		setDownloading(true);
		fetchAndSetAllETs()
			.then(() => setPartialUploadPopupVisible(true))
			.catch(message.error)
			.finally(() => setDownloading(false));
	}, [fetchAndSetAllETs]);

	const _hideUploadPopup = useCallback(() => setUploadPopupVisible(false), []);
	const _hidePartialUploadPopup = () => setPartialUploadPopupVisible(false);

	const exportAsCsv = useCallback(
		(eqs, getRecord = getFlatfileRecordForReceivedEquipmentExport) => {
			const date = moment().format(DATE_FORMAT);
			const csvTitle = `${stockLocation.name}_${date}_received_equipment`;
			const csvExporter = new ExportToCsv({
				...CSV_EXPORT_DEFAULTS,
				filename: csvTitle,
				title: csvTitle,
				headers: EQUIPMENT_EXPORT_HEADER,
			});

			const data = eqs && eqs.length > 0 ? eqs.map((_) => getRecord(_)) : [getRecord()];
			csvExporter.generateCsv(data);
		},
		[stockLocation.name]
	);

	const onDownloadSample = useCallback(() => {
		exportAsCsv(esplsForUpload);
	}, [esplsForUpload, exportAsCsv]);

	const downloadCSV = useCallback(() => {
		setExportingCsv(true);
		exportCsv({
			...getStateSliceProp('sorting'),
			...getStateSliceProp('filters'),
		}).finally(() => setExportingCsv(false));
	}, [exportCsv, getStateSliceProp]);

	const getEntityForUpload = useCallback(
		(record) => {
			const { equipmentId, ...entity } = getFlatfileRecordForReceivedEquipmentExport(record);
			return {
				...entity,
				equipmentId: equipmentId || undefined,
				cost: record.cost ? parseFloat(record.cost) : undefined,
				stockLocationId: parseInt(stockLocationId),
				equipmentTypeId: parseInt(record.equipmentTypeId),
			};
		},
		[stockLocationId]
	);

	const onDataUpload = useCallback(
		(results) => {
			return new Promise((resolve, reject) => {
				setBulkUploadInProgress(true);
				setBulkUploadInitiated(true);
				createBulk(results.validData.map((_) => getEntityForUpload(_)))
					.then((res) => {
						resolve('Updated successfully!');
						setTimeout(() => {
							_hideUploadPopup();
						}, 0);
					})
					.catch((err) => {
						reject(err || 'Unable to upload! Please contact support!');
						setBulkUploadInitiated(false);
					})
					.finally(() => setBulkUploadInProgress(false));
			});
		},
		[_hideUploadPopup, createBulk, getEntityForUpload]
	);

	const onPartialDataUpload = useCallback(
		(results) => {
			return new Promise((resolve, reject) => {
				const entities = results.validData.map((_) => getEntityForUpload(_));

				setBulkUploadInProgress(true);
				setBulkUploadInitiated(true);
				uploadPartialBulk(entities)
					.then((res) => {
						resolve('Upload initiated successfully!');
						setTimeout(() => {
							_hidePartialUploadPopup();
						}, 0);
					})
					.catch((err) => {
						reject(err || 'Unable to upload! Please contact support!');
						setBulkUploadInitiated(false);
					})
					.finally(() => setBulkUploadInProgress(false));
			});
		},
		[getEntityForUpload, uploadPartialBulk]
	);

	const uploadMenu = (
		<Menu>
			<Menu.Item onClick={onUploadClick}>All Equipment</Menu.Item>
			<Menu.Item onClick={onPartialUploadClick}>Partial Upload</Menu.Item>
		</Menu>
	);

	const onEditDataSuccess = useCallback(
		(results) => {
			return new Promise((resolve, reject) => {
				createBulk(
					results.validData.map((_) => ({
						...getFlatfileRecordForReceivedEquipment(_),
						id: _.id ? parseInt(_.id) : undefined,
						cost: _.cost ? parseFloat(_.cost) : undefined,
						stockLocationId: parseInt(stockLocationId),
						equipmentTypeId: parseInt(_.equipmentTypeId),
					}))
				)
					.then((res) => {
						resolve('Updated successfully!');
						message.success('Updated successfully!');
					})
					.catch((err) => {
						console.log(err);
						reject('Unable to upload! Please contact support!');
					});
			});
		},
		[createBulk, stockLocationId]
	);

	const onBulkEpslEditSuccess = useCallback(() => {
		setEpsls([]);
		setCanShowEdit(false);
		refreshEquipmentsPerStockLocation();
	}, [refreshEquipmentsPerStockLocation]);

	return (
		<>
			<PaginatedReduxTableWithHeader
				targetCollectionName={EPSL_TC}
				updateFilters={updateEquipmentsPerStocklocationFilters}
				stateSlice={equipmentsPerStockLocation}
				clearAndUpdateFilters={clearAndUpdateFilters}
				filterConfig={filterConfig}
				entityCollectionName="equipment_per_stock_locations"
				tableColumns={equipmentsColumns}
				onTableRow={onEquipmentRow}
				rowSelection={canFieldManageStockLocation(currentUser, stockLocation) ? rowSelection : null}
				showHeader
				preAppliedFilters={preAppliedFilters}
				fetchData={equipmentPerStockLocationsRestCrudThunksForSupplier.read}
				hasDefaultHeaderPage
				initialSorters={RECENTLY_UPDATED_SORTER}
				rightActions={
					canTransfer ? (
						<div>
							<Button onClick={onSelectCancel} size="large">
								Cancel
							</Button>
							<TransferEPSLButton
								stockLocationId={stockLocationId}
								onTransferSuccess={onTransferEquipmentsSuccess}
								selectedRecords={selectedRecords}
							/>
						</div>
					) : (
						<div className="flex-start flex flex-row">
							<Popover content="View Printable Labels" trigger="hover">
								<Button
									size="large"
									icon={<PrinterOutlined />}
									onClick={() =>
										history.push(
											getLink(`/supplier/stockLocations/printEquipmentLabels/${stockLocationId}`)
										)
									}
								/>
							</Popover>
							<FeildTechSLManagePermissionChecker>
								<Popover content="Export CSV" trigger="hover">
									<Button
										size="large"
										icon={<DownloadOutlined />}
										className="inline-block-visible-md ml-2"
										onClick={downloadCSV}
										loading={exportingCsv}
										disabled={!editAllowed}
									>
										<span className="inline-block-visible-xxl">Export CSV</span>
									</Button>
								</Popover>
								{bulkUploadInProgress ? null : (
									<OWPoll
										key="sl-equ-upload"
										id="sl-equ-upload"
										fetchStatusPromises={[getBulkUploadStatus]}
										successMessage="Equipment Upload Completed!"
										message="Equipment Upload in progress!"
										onRefresh={refreshEquipmentsPerStockLocation}
										successMessageMandatory={bulkUploadInitiated}
										renderElementWithProps={(props) => (
											<>
												<Dropdown overlay={uploadMenu} {...props}>
													<Button
														size="large"
														className="inline-block-visible-md ml-2"
														icon={<UploadOutlined />}
														loading={downloading}
													>
														<span className="inline-block-visible-xxl">Upload</span>
													</Button>
												</Dropdown>
												<Popover
													content={
														editAllowed
															? 'Edit Received Equipment'
															: 'No Equipment available to edit'
													}
													trigger="hover"
												>
													<Button
														className="ml-2"
														size="large"
														loading={fetchingEpsl}
														icon={<EditOutlined />}
														onClick={onBulkEpslEdit}
														disabled={props.disabled || !editAllowed}
													>
														Edit
													</Button>
												</Popover>
											</>
										)}
									/>
								)}
								<Button
									className="ml-2"
									size="large"
									icon={<PlusOutlined />}
									type="primary"
									onClick={onAddEquipment}
								>
									Add
								</Button>
							</FeildTechSLManagePermissionChecker>
						</div>
					)
				}
				emptyState={
					<EmptyState
						graphic={
							<img
								style={{ marginBottom: 8 }}
								src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
								alt="The tool shed is looking pretty empty."
							/>
						}
						headline={'The tool shed is looking pretty empty.'}
						body={
							<div style={{ textAlign: 'center' }}>
								<div style={{ maxWidth: 440, marginBottom: 16 }}>
									You haven't added any equipment to this location yet.
								</div>
							</div>
						}
					/>
				}
			/>
			{canShowEdit ? (
				<FlatfileImporter
					dataLoadComplete={canShowEdit}
					type="equipment_level"
					fields={getReceivedEquipmentFlatfileHeader(allEquipmentTypesNames)}
					data={epsls.map((_) => getFlatfileRecordForReceivedEquipment(_))}
					onComplete={onBulkEpslEditSuccess}
					onDataLoad={onEditDataSuccess}
				/>
			) : null}
			{uploadPopupVisible && (
				<UploadWithSampleModal
					type="Received Equipment"
					title="Upload Received Equipment"
					downloadText="Do you want to download the existing equipment?"
					sampleFileText="Download Received Equipment"
					onCancel={_hideUploadPopup}
					onDownloadSample={onDownloadSample}
					fields={getReceivedEquipmentFlatfileHeader(allEquipmentTypesNames)}
					onDataLoad={onDataUpload}
					showWarningMessage
				/>
			)}
			{partialUploadPopupVisible && (
				<PartialEPSLUpload
					onDataUpload={onPartialDataUpload}
					hideUploadPopup={_hidePartialUploadPopup}
					allEquipmentTypesNames={allEquipmentTypesNames}
				/>
			)}
		</>
	);
};

const mapStateToProps = (state, ownProps) => ({
	match: ownProps.match,
	history: ownProps.history,
	location: ownProps.location,
	stockLocation: state.stock_locations.detail,
	currentUser: state.session.currentUser,
	equipmentsPerStockLocation: state.equipment_per_stock_locations,
	assetTypes: state.asset_types,
	equipmentTypes: state.equipment_types,
	vendors: state.vendors,
});

const mapDispatchToProps = (dispatch) => ({
	fetchEquipmentsPerStockLocation: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			equipmentPerStockLocationsRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	updateEquipmentsPerStocklocationFilters: (filters, targetCollection) =>
		dispatch(
			EQUIPMENT_PER_STOCK_LOCATIONS_CRUD_ACTION_CREATORS.updateFilters(filters, targetCollection)
		),
	clearAndUpdateFilters: (filters, targetCollectionName) =>
		dispatch(
			EQUIPMENT_PER_STOCK_LOCATIONS_CRUD_ACTION_CREATORS.clearAndUpdateFilters(
				filters,
				targetCollectionName
			)
		),
	fetchMultipleAssetTypes: (ids, targetCollectionName) =>
		dispatch(assetTypesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchAssetTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			assetTypesRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleEquipments: (ids, targetCollectionName) =>
		dispatch(equipmentTypesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchEquipmentTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			equipmentTypesRestCrudThunksForSupplier.read(
				{ ...(params || {}), isActive: true },
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	createBulk: (entities) =>
		dispatch(equipmentPerStockLocationsRestCrudThunksForSupplier.createBulk(entities)),
	fetchAllEquipmentPerStockLocation: (params) =>
		dispatch(fetchAllEquipmentPerStockLocactionForSupplier(params, RECENTLY_UPDATED_SORTER)),
	fetchAllEquipmentTypes: () =>
		dispatch(equipmentTypesRestCrudThunksForSupplier.readLite({ no_pagination: true })),
	exportCsv: (params) => dispatch(equipmentPerStockLocationCsvReportGeneratorSupplier(params)),
	getBulkUploadStatus: () => dispatch(getEPSLUploadBulkStatus(ROLE_TYPES.SUPPLIER)()),
	uploadPartialBulk: (entities) => dispatch(uploadPartialEPSLBulk(ROLE_TYPES.SUPPLIER)(entities)),
	fetchVendors: (params, targetCollectionName) =>
		dispatch(
			vendorsRestCrudThunksForSupplier.readLite(
				{ ...params, isActive: true, no_pagination: true },
				targetCollectionName
			)
		),
	fetchMultipleVendors: (ids, targetCollectionName) =>
		dispatch(vendorsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(StockLocationEquipmentsPage)
);
